var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1163.5 2354C1806.08 2354 2327 1827.04 2327 1177C2327 526.961 1806.08 0 1163.5 0C520.919 0 0 526.961 0 1177C0 1827.04 520.919 2354 1163.5 2354Z","fill":"url(#paint0_linear_5103_1210)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_5103_1210","x1":"1163.5","y1":"0","x2":"1163.5","y2":"2354","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#33D5B5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#85DE5E","key":1})]))]);
}

Circle.defaultProps = {"width":"1927","height":"1954","viewBox":"0 0 2327 2354","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
